<template>
  <HeaderGame />
  <div class="helper-page">

    <!-- 搜索 -->
    <div class="search-wrapper">
      <van-search 
        v-model="search_val" 
        show-action 
        :placeholder="$t('LAN.search_placeholder')"
        @search="onSearch"
        @input="onInput"
        @focus="onFocus"
        @blur="onBlur"
        @clear="onClear"
      >
        <template #action>
          <div class="search-action" @click="onSearch">{{ $t("LAN.search") }}</div>
        </template>
      </van-search>

      <!-- 搜索下拉 -->
      <div class="search-dropdown" v-show="search && searchList.length">
        <ul class="search-list">
          <li
            v-for="(item, key) in searchList"
            :key="key"
            v-html="item.showQues"
            @mousedown="
              search_val = item.question;
              onSearch();
            "
          />
        </ul>
      </div>
    </div>

    <!-- 问题分类 -->
    <div class="question-wrapper">
      <van-tabs :before-change="onQuesBeforeChange" animated :ellipsis="false" color="#6387ea">
        <van-tab v-for="tab in questionTabs" :title="tab.name" :key="tab.type">
          <div class="question-content">
            <van-empty :description="$t('LAN.empty')" v-show="questions.length < 1" />
            <ul class="question-list" v-show="questions.length > 0">
              <li v-for="item in questions" :key="item.id" @click="onClickQuesItem(item)">
                {{ item.question }}
              </li>
            </ul>
          </div>
        </van-tab>
      </van-tabs>
    </div>

    <!-- 自助服务 -->
    <div class="self-service">
      <div class="section-title">
        <h2>{{ $t("LAN.self_service") }}</h2>
      </div>
      <div class="service-menu">
        <div class="service-item" @click="goTo('feedbackLink')">
          <img :src="require('@/assets/helper/icon_tjfk.png')" alt="" />
          <p>{{ $t("LAN.submit_feedback") }}</p>
        </div>
        <div class="service-item" @click="goTo('robotLink')">
          <img :src="require('@/assets/helper/icon_zxkf.png')" alt="" />
          <p>{{ $t("LAN.online_service") }}</p>
        </div>
        <div class="service-item" @click="goTo('feedbackMyServiceLink')">
          <img :src="require('@/assets/helper/icon_wdfk.png')" alt="" />
          <p>{{ $t("LAN.myservice") }}</p>
        </div>
        <div v-if="showVip" class="service-item" @click="goTo('supervipLink')">
          <img :src="require('@/assets/helper/icon_vipkf.png')" alt="" />
          <p>{{ $t("LAN.vip_kf") }}</p>
        </div>
      </div>
    </div>

    <nav-bar />
  </div>
</template>

<script>
import { reactive, onMounted, toRefs } from "vue";
import { useRouter } from "vue-router";
import NavBar from "@/components/NavBar";
import HeaderGame from '@/components/HeaderGame'
import { useStore } from "vuex";
import { Toast } from "vant";
import {
  loadConfig,
  searchQuestions,
  saveSearchHistory,
} from "@/utils/questions";
import { useI18n } from "vue-i18n";
import { switchAccount } from "@/utils/common";
import { CHANNEL } from "@/configs/global";
import { validateNull } from "@/utils/validate";

export default {
  name: "helper",
  setup() {
    const store = useStore();
    const router = useRouter();
    const { t } = useI18n();

    const state = reactive({
      username: "",
      gamename: "",
      search: false,
      searchList: [],
      search_val: "",
      questionTabs: [
        { type: 1, name: t("LAN.questionTabs_1") },
        { type: 2, name: t("LAN.questionTabs_2") },
        { type: 3, name: t("LAN.questionTabs_3") },
        { type: 4, name: t("LAN.questionTabs_4") },
        { type: 999, name: t("LAN.questionTabs_999") },
      ],
      questionsCfg: null,
      questions: [],
      showSwitchBtn: true,
      avatar: "",
      showVip: false,
    });

    onMounted(() => {
      // Toast.loading(t("LAN.loading"));
      store.commit("setNeedLogin", false);
      loadConfig(initData);
      state.username = store.getters.username;
      state.gamename = store.getters.gameName;
      state.showSwitchBtn = store.getters.channel != CHANNEL.FACEBOOK;
      if (validateNull(store.getters.avatar)) {
        state.avatar = "https://handzone-1259199078.file.myqcloud.com/feedback/2022-10/1666165741095.jpg";
      } else {
        state.avatar = store.getters.avatar.replace("http://", "https://");
      }
      state.showVip = store.getters.channel != CHANNEL.APPLE_STORE && store.getters.channel != CHANNEL.FACEBOOK && store.getters.isOtherPayMode;
    });

    const initData = (questionCfg) => {
      state.questionsCfg = questionCfg;
      onQuesBeforeChange(0);
      Toast.clear();
    };
    const onSearch = () => {
      saveSearchHistory(state.search_val);
      goTo("questionsLink", { search: state.search_val });
    };

    const goTo = (name, params) => {
      router.push({ name: name, query: params });
    };

    const onQuesBeforeChange = (index) => {
      let type = state.questionTabs[index].type;
      if (type == 999) {
        goTo("questionsLink");
        return false;
      }
      state.questions = [];
      let questionsCfg = state.questionsCfg;
      if (questionsCfg) {
        for (const key in questionsCfg) {
          if (key == type) {
            for (const id in questionsCfg[key]) {
              state.questions.push(questionsCfg[key][id]);
            }
          }
        }
      }
      return true;
    };

    const onFocus = () => {
      state.search = true;
      onInput();
    };

    const onBlur = () => {
      setTimeout(() => {
        state.search = false;
      }, 200);
    };

    const onClear = () => {
      state.searchList = [];
      state.search = false;
    };

    const onInput = () => {
      state.searchList = searchQuestions(state.questionsCfg, state.search_val);
    };

    const onClickQuesItem = (item) => {
      goTo("questionsDetailLink", item);
    };

    return {
      ...toRefs(state),
      goTo,
      onQuesBeforeChange,
      onSearch,
      onFocus,
      onInput,
      onBlur,
      onClear,
      onClickQuesItem,
      switchAccount,
    };
  },
  components: {
    NavBar,
    HeaderGame
  },
};
</script>

<style lang="less" scoped>
/* 页面整体 */
.helper-page {
  width: 100%;
  min-height: 100vh;
  background-color: #f7f8fa;
  padding-bottom: 80px;
  box-sizing: border-box;
}

/* 搜索 */
.search-wrapper {
  padding: 16px;
  background: #fff;
  position: relative;
  z-index: 10;
}

.search-action {
  font-size: 15px;
  color: #6e87ea;
  padding: 0 12px;
}

.search-dropdown {
  position: absolute;
  left: 16px;
  right: 16px;
  top: 60px;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  max-height: 220px;
  overflow: hidden;
  z-index: 99;
}

.search-list {
  list-style: none;
  margin: 0;
  padding: 0;
}

.search-list li {
  padding: 12px 16px;
  font-size: 15px;
  color: #333;
  border-bottom: 1px solid #f2f3f5;
  cursor: pointer;
}

.search-list li:last-child {
  border-bottom: none;
}

/* 问题区域 */
.question-wrapper {
  margin-top: 10px;
  background: #fff;
  border-radius: 16px;
  margin: 10px 16px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.question-content {
  padding: 12px 20px;
}

.question-list {
  list-style: none;
  margin: 0;
  padding: 0;
  max-height: 38vh;
  overflow-y: auto;
}

.question-list li {
  height: 48px;
  line-height: 48px;
  font-size: 15px;
  text-align: left;
  color: #333;
  border-bottom: 1px solid #f2f3f5;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}

.question-list li:last-child {
  border-bottom: none;
}

/* 自助服务 */
.self-service {
  margin-top: 20px;
  background: #fff;
  border-radius: 16px;
  margin: 20px 16px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
}

.section-title {
  margin-bottom: 16px;
}

.section-title h2 {
  font-size: 18px;
  font-weight: 500;
  color: #333;
  margin: 0;
}

.service-menu {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.service-item {
  flex: 1;
  min-width: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 12px 4px;
  border-radius: 12px;
  background: #f9fafb;
  cursor: pointer;
}

.service-item img {
  width: 36px;
  height: 36px;
}

.service-item p {
  font-size: 13px;
  color: #666;
  margin: 0;
  text-align: center;
}
</style>